import styled from "styled-components";

export const SectionCardContainer = styled.div`
  overflow: hidden;
  height: 23.125rem;
  padding: 0;
  margin: 1.875rem 0rem;

  & div {
    height: 100%;
    width: 100%;

    .width-hald {
      width: 50%;
    }
  }

  .container__standart {
    padding: 0;
  }

  .section-card__info {
    color: white;
    flex-direction: column;
    align-items: flex-start;
    padding: 0rem 1.25rem;
    & p {
      margin: 1.25rem 0rem;
    }
  }

  .relative__container {
    position: relative;
    width: 100%;
    overflow: hidden;

    & img {
      position: absolute;
      top: 0px;
      left: 0;
      width: 55vw;
      height: 100%;
    }
  }

  @media (max-width: 998px) {
    & img {
      width: 100% !important;
      transform: scale(1.5);
    }
    .section-card__info {
      padding: 1.25rem;
    }
    .adaptive__direction {
      flex-direction: column !important;
    }
  }

  @media (max-width: 768px) {
    height: 31.125rem;
  }
`;
